export default API => ({
    //根据名称查询城市列表
    findCity(data) {
        return API({
            url:`/company/v1/region/findCityByName?name=${data.name}`,
            method:'get',
            data
        });
    },
    //获取定位城市
    getLocatingCity(data) {
        return API({
            url:'/company/v1/region/locatingCity',
            method:'get',
            data
        });
    },
    //获取城市列表
    getCities(data) {
        return API({
            url:'/company/v1/region/regionListForH5',
            method:'get',
            data
        });
    },

    //招聘列表
    findByCondition(data) {
        return API({
            url:`/company/v1/stu/position/findByCondition` ,
            method:'post',
            data
        });
    },
})
